import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function dataTutotrial(params) {
    return client.get("/tunnel/api/pos/tutorial/data", {
        params: params,
    });
}

function detailTutorial(params) {
    return client.get("/tunnel/api/pos/tutorial/detail", {
        params: params,
    });
}

function dataOptionTutorialCategory() {
    return client.get("/tunnel/api/pos/common/tutorial_category");
}

export default {
    dataTutotrial,
    detailTutorial,
    dataOptionTutorialCategory
};